import { decodeUUID, type UUID } from './uuid'
import type { InstructionPayload } from '@/store/types'
import { decodeInstructionVersion, type InstructionVersion } from './instructionVersion'

export type Instruction = {
  id: UUID
  title: string
  activeVersion: InstructionVersion
}

export const decodeInstruction = (instructionPayload: InstructionPayload): Instruction => ({
  id: decodeUUID(instructionPayload.id),
  title: instructionPayload.title,
  activeVersion: decodeInstructionVersion(instructionPayload.active_version),
})
